import React, { FormEvent, KeyboardEvent, useState } from 'react'
import styles from './index.module.scss'

interface BoardCreateFastTaskProps {
    onClose: () => void
    onCreate: (title: string) => Promise<void> | void
}

export default function BoardCreateFastTask({ onClose, onCreate }: BoardCreateFastTaskProps){
    const [title, setTitle] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [hasError, setHasError] = useState(false)

    const submitTask = async (event?: FormEvent) => {
        event?.preventDefault()

        const normalizedTitle = title.trim()
        if (!normalizedTitle || isSubmitting) {
            return
        }

        setIsSubmitting(true)
        setHasError(false)

        try {
            await onCreate(normalizedTitle)
        } catch (error) {
            console.error('Failed to create task from board column:', error)
            setHasError(true)
        } finally {
            setIsSubmitting(false)
        }
    }

    const handleKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault()
            void submitTask()
        }
    }

    return (
        <form className={styles.boardCreateFastTask} onSubmit={submitTask}>
            <div className={styles.boardCreateFastTask__input}>
                <textarea
                    autoFocus
                    disabled={isSubmitting}
                    onChange={(event) => {
                        setTitle(event.target.value)
                        setHasError(false)
                    }}
                    onKeyDown={handleKeyDown}
                    placeholder="Введите название задачи"
                    value={title}
                />
            </div>
            {hasError ? (
                <div className={styles.boardCreateFastTask__error}>Не удалось создать задачу</div>
            ) : null}
            <div className={styles.boardCreateFastTask__actions}>
                <button
                    className={styles.boardCreateFastTask__btn}
                    disabled={!title.trim() || isSubmitting}
                    type="submit"
                >
                    {isSubmitting ? 'Создание...' : 'Создать задачу'}
                </button>
                <button
                    aria-label="Закрыть быстрое создание задачи"
                    className={styles.boardCreateFastTask__close}
                    disabled={isSubmitting}
                    onClick={onClose}
                    type="button"
                >
                    <img src="/icon/close.svg" alt=""/>
                </button>
            </div>
        </form>
    )
}
